import { render } from "./Navigation.vue?vue&type=template&id=4b6b8444&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=4b6b8444&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4b6b8444"

export default script